export type ApiEnvelope<T = unknown> = {
  data?: T | null;
  error?: boolean;
  success?: boolean;
  message?: string;
  userMessage?: string;
  technicalError?: unknown;
};

export class ApiEnvelopeError extends Error {
  response?: { data: ApiEnvelope };
  envelope: ApiEnvelope;
  userMessage: string;

  constructor(envelope: ApiEnvelope, fallback = "A operação retornou erro.") {
    const userMessage =
      envelope.userMessage || envelope.message || fallback;

    super(userMessage);
    this.name = "ApiEnvelopeError";
    this.envelope = envelope;
    this.userMessage = userMessage;
    this.response = { data: envelope };
  }
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  Boolean(value) && typeof value === "object" && !Array.isArray(value);

export const isApiEnvelopeFailure = (value: unknown): value is ApiEnvelope =>
  isRecord(value) &&
  (value.error === true || value.success === false);

export const assertApiEnvelopeSuccess = <T>(
  value: T,
  fallback?: string,
): T => {
  if (isApiEnvelopeFailure(value)) {
    throw new ApiEnvelopeError(value, fallback);
  }

  return value;
};

export const unwrapApiEnvelope = <T>(
  envelope: ApiEnvelope<T>,
  fallback?: string,
): T => {
  assertApiEnvelopeSuccess(envelope, fallback);
  return envelope.data as T;
};
